export default __webpack_public_path__ + "static/safe-tourism.en-ba3b04bb337d3925330c1918db9c0edf.png";